var React = require('react');

function Es (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("path",{"d":"M2 12.0001C2 13.2233 2.22004 14.395 2.62199 15.4783L12 16.3479L21.378 15.4783C21.78 14.395 22 13.2233 22 12.0001C22 10.7769 21.78 9.60516 21.378 8.52183L12 7.65226L2.62199 8.52183C2.22004 9.60516 2 10.7769 2 12.0001Z","fill":"#FFDA44","key":1}),React.createElement("path",{"d":"M21.3781 8.52176C19.9652 4.71379 16.2997 2 12.0001 2C7.70043 2 4.035 4.71379 2.62207 8.52176H21.3781Z","fill":"#D80027","key":2}),React.createElement("path",{"d":"M2.62207 15.4783C4.035 19.2863 7.70043 22.0001 12.0001 22.0001C16.2997 22.0001 19.9652 19.2863 21.3781 15.4783H2.62207Z","fill":"#D80027","key":3})]);
}

Es.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Es;

Es.default = Es;
